import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { QuestionnaireComponent } from "./questionnaire.component";
import { RouterModule, Routes } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { GetControlModule } from "../get-control/get-control.module";
import { FileDetailsModule } from "app/pipes/file-details/file-details.module";
import { ProgressModule } from "app/shared/progress/progress.module";
import { DocumentViewerModule } from "app/shared/document-viewer/document-viewer.module";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { NgxLoadingModule } from "ngx-loading";

// const routes: Routes = [{ path: "", component: QuestionnaireComponent }];

@NgModule({
  declarations: [QuestionnaireComponent],
  imports: [
    CommonModule,
    // RouterModule.forChild(routes),OcasModule
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    GetControlModule,
    FileDetailsModule,
    ProgressModule,
    DocumentViewerModule,
    PdfViewerModule,
    NgxLoadingModule,
  ],
  exports: [QuestionnaireComponent],
})
export class QuestionnaireModule {}
